import {useEffect, useRef, useState} from "react"

import Grid from '@material-ui/core/Grid'

import Dialog from "@base/Dialog";
import {ButtonSave} from "@base/Button/ButtonForm"
import TextField from '@base/Inputs/Text/TextField'
import SelectOption from '@base/Inputs/Select/Select'
import EscolaService from '@services/EscolaService'
import VisualizadorDeArquivo from '@base/VisualizadorDeArquivo';
import CircularProgress from '@material-ui/core/CircularProgress'
import {cpfMask} from '@helpers/MaskHelper'
import Toast from "@base/Toast";

import useStatusPendencia from '@hooks/enums/useStatusPendencia';
import useOrigemProblema from '@hooks/enums/useOrigemProblema';

export const TratamentoCPFDialog = (props) => {
  const processo = props.processo;

  const listagemStatus = useStatusPendencia();
  const listagemOrigemProblema = useOrigemProblema();
  
  const [, setFormId] = useState("");
  const [formTratamentoStatus, setFormTratamentoStatus] = useState("");
  const [formOrigemProblema, setFormOrigemProblema] = useState("");
  const [formOrigemProblemaOutro, setFormOrigemProblemaOutro] = useState("");
  const [formTratamentoEscola, setFormTratamentoEscola] = useState("");
  const [, setFormTratamentoCartaoId] = useState("");
  const [formTratamentoCartao, setFormTratamentoCartao] = useState("");
  const [formTratamentoCPF, setFormTratamentoCPF] = useState("");
  const [formTratamentoPendencia, setFormTratamentoPendencia] = useState("");
  const [blob, setBlob] = useState();
  const [loading, setLoading] = useState(false);
  const toastRef = useRef(null);

  const buttonsSubmit = () => !loading ? <ButtonSave onClick={tratarPendencia}/> : <><CircularProgress
    size={16}/> Aguarde...</>
  const isValido = (obj) => {

    let mensagem = "";

    if (obj === null || obj === undefined) {
      mensagem += `<li>O campo 'CPF' é obrigatório.</li>`;
    } else if (obj.length < 11 && obj !== "@@") {
      mensagem += `<li>O campo 'CPF' deve possuir 11 caracteres, ou @@.</li>`;
    }

    return {
      ok: mensagem === "",
      mensagem: `${mensagem}`
    }
  }

  const tratarPendencia = () => {
    setLoading(true);

    let obj = {
      status: formTratamentoStatus === "" ? undefined : formTratamentoStatus,
      cpfSubstituto: formTratamentoCPF,
      origemProblema: formOrigemProblema === "" ? undefined : formOrigemProblema,
      descricaoOrigemOutro: formOrigemProblemaOutro === "" ? undefined : formOrigemProblemaOutro,
    };

    let valido = isValido(obj.cpfSubstituto);
    if (valido.ok) {
      EscolaService.atualizarStatusTratamentoCpf(props.processo, props.id, obj).then(resultado => {
        props.handleSave(resultado);
        props.toastReference.current.show("success", "CPF tratado com sucesso.");
        props.handleClose();
        setLoading(false);
      }).catch(error => {
        console.log(error)
        props.toastReference.current.show("error", "Erro" + error.response.data.mensagens.map(mensagem => mensagem).join(" ,"));
        setLoading(false);
      })
    } else {
      toastRef.current.show("warning", "Erro de validação! " + valido.mensagem);
      setLoading(false);
    }
    ;
  }

  const limparEstado = () => {
    setFormId("");
    setFormTratamentoStatus("");
    setFormTratamentoPendencia("");
    setFormTratamentoEscola("");
    setFormTratamentoCartao("");
    setFormTratamentoCartaoId("");
    setFormTratamentoCPF("");
  }

  useEffect(() => {
    setFormId(props.id);
  }, [props.id]);

  useEffect(() => {
    if (props.id) {

      EscolaService.downloadArquivoCartao(processo, undefined, props.id).then(resposta => {
        setBlob(resposta.data);
      });

      EscolaService.buscaDadosDoCartao(processo, props.id).then(resposta => {

        let pendencia = resposta;

        if (pendencia.data.tratamentoCpf) {
          setFormTratamentoStatus(pendencia.data.tratamentoCpf.status);
          setFormTratamentoPendencia(pendencia.data.tratamentoCpf.tipoLabel);
          setFormOrigemProblema(pendencia.data.tratamentoCpf.origem);
          setFormOrigemProblemaOutro(pendencia.data.tratamentoCpf.descricaoOrigemOutro);
        }
        setFormTratamentoEscola(pendencia.data.escola);
        setFormTratamentoCartao(pendencia.data.codigo);
        setFormTratamentoCartaoId(pendencia.data.id);
        setFormTratamentoCPF(pendencia.data.cpf);
      });


    }
  }, [processo, props.id, props.codigo]);

  return (
    <>
      <Toast ref={toastRef}/>
      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        closeDialog={() => {
          limparEstado();
          props.handleClose();
        }}
        openDialog={props.open}
        title="Tratar CPF"
        actions={buttonsSubmit()}
      >

        <Grid container spacing={3}>
          <Grid item sm={4}>
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <TextField disabled label="Escola" value={formTratamentoEscola}/>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <TextField disabled label="Código do Cartão" value={formTratamentoCartao}/>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item sm={12}>
                <TextField disabled label="Pendência" value={formTratamentoPendencia}/>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <SelectOption
                  label='Status'
                  required
                  value={formTratamentoStatus}
                  name='formTratamentoStatus'
                  onChange={(e) => setFormTratamentoStatus(e.target.value)}
                  options={listagemStatus.data}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item sm={12}>
                <SelectOption
                  label='Origem do Problema'
                  required={formTratamentoStatus === 'RESOLVIDA'}
                  value={formOrigemProblema}
                  name='formOrigemProblema'
                  onChange={(e) => setFormOrigemProblema(e.target.value)}
                  options={listagemOrigemProblema.data}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              {formOrigemProblema === "OUTRO" &&
                <Grid item sm={12}>
                  <TextField label="Qual foi o problema?" value={formOrigemProblemaOutro}
                             onChange={(e) => setFormOrigemProblemaOutro(e.target.value)}/>
                </Grid>
              }
            </Grid>

            <Grid container spacing={3}>
              <Grid item sm={12}>
                <TextField label="CPF" value={formTratamentoCPF}
                           required
                           autoComplete="off"
                           onChange={(e) => setFormTratamentoCPF(cpfMask(e.target.value))}/>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={8}>
            {blob ? <VisualizadorDeArquivo

                blob={blob}
              />
              : <CircularProgress size={16}/>}
          </Grid>
        </Grid>

      </Dialog>
    </>
  );
}

export default TratamentoCPFDialog;
